import { render, staticRenderFns } from "./ResultPage.vue?vue&type=template&id=55543652&scoped=true&"
import script from "./ResultPage.vue?vue&type=script&lang=js&"
export * from "./ResultPage.vue?vue&type=script&lang=js&"
import style0 from "./ResultPage.vue?vue&type=style&index=0&id=55543652&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55543652",
  null
  
)

export default component.exports